module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 10\"><path fill-rule=\"evenodd\" d=\"M6 4V0H4v4H0v2h4v4h2V6h4V4H6z\"></path></svg>"